import { render, staticRenderFns } from "./EmbedIde.vue?vue&type=template&id=6b265505&scoped=true"
import script from "./EmbedIde.vue?vue&type=script&lang=js"
export * from "./EmbedIde.vue?vue&type=script&lang=js"
import style0 from "./EmbedIde.vue?vue&type=style&index=0&id=6b265505&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b265505",
  null
  
)

export default component.exports